import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { authBackendEndPointToken } from './app.config';

export interface PatientsResolverData {
  patients: any[];
  total: number;
  pageSize: number;
  pageIndex: number;
}

/**
 * Resolver for initial page load - fetches first page of patients
 * This is faster than waiting for component to initialize
 */
export const patientsResolver: ResolveFn<PatientsResolverData> = (route, state) => {
  const http = inject(HttpClient);
  const authBackendUrl = inject(authBackendEndPointToken);

  // Load first page (10 items, offset 0)
  const pageSize = 10;
  const pageIndex = 0;

  let params = new HttpParams()
    .set('active', 'true')
    .set('deceased', 'false')
    .set('_count', pageSize.toString())
    // .set('_offset', (pageIndex * pageSize).toString());

  const url = `${authBackendUrl}/fhir/Patient`;

  //console.log('Resolver: Loading initial patients page');

  return http.get(url, { params }).pipe(
    map((response: any) => {
      //console.log('Resolver: Server response received');

      if (!response) {
        return { patients: [], total: 0, pageSize, pageIndex };
      }

      let patients: any[] = [];
      let total = 0;

      // Handle FHIR Bundle response
      if (response.entry && Array.isArray(response.entry)) {
        patients = response.entry
          .map((entry: any) => entry.resource)
          .filter(Boolean);
        total = response.total || patients.length;
      } else if (Array.isArray(response)) {
        patients = response;
        total = patients.length;
      } else if (response && typeof response === 'object') {
        patients = [response];
        total = 1;
      }

      console.log(`Resolver: Loaded ${patients.length} patients (${total} total)`);

      return {
        patients,
        total,
        pageSize,
        pageIndex
      };
    }),
    catchError((error) => {
      console.error('Resolver: Error loading patients:', error);
      // Return empty data on error - component will handle error state
      return of({ patients: [], total: 0, pageSize, pageIndex });
    })
  );
};